import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sf-heading sf-section-title px-4 sm:px-0"
}
const _hoisted_2 = {
  key: 0,
  class: "home__categories-list sm:pb-8 sm:pt-6"
}
const _hoisted_3 = { class: "transition-transform transform-gpu hover:scale-110 cursor-pointer home__categories-list__category items-center" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "text-center text-sm only-1-lines" }
const _hoisted_6 = {
  key: 1,
  class: "home__categories-list sm:pb-8 sm:pt-6"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "cursor-pointer home__categories-list__category skeleton animate-pulse" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "img-skeleton rounded-2xl sf-skeleton w-full" }),
    /*#__PURE__*/_createElementVNode("p", { class: "text-center mx-auto p-skeleton sf-skeleton text-sm h-4 w-full" })
  ])
], -1)
const _hoisted_8 = {
  key: 0,
  class: "sf-categories__grid px-4 sm:px-0 pb-8 pt-2"
}
const _hoisted_9 = { class: "sf-categories__tile-img" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "text-center text-sm font-medium only-1-lines pt-2" }
const _hoisted_12 = {
  key: 1,
  class: "sf-categories__grid px-4 sm:px-0 pb-8 pt-2 animate-pulse"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "sf-categories__tile-img sf-skeleton" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "sf-skeleton h-4 mt-2 w-full" }, null, -1)
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = {
  key: 0,
  class: "sf-categories__chips px-4 sm:px-0 pb-8 pt-2"
}
const _hoisted_17 = {
  key: 1,
  class: "sf-categories__chips px-4 sm:px-0 pb-8 pt-2 animate-pulse"
}

import { computed } from 'vue'
import { Pagination, FreeMode } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import 'swiper/css/pagination'
import { restaurant, categories, getProductImage } from '@/global/state/GlobalState'
import { CategoriesSection } from '@/global/state/StorefrontState'

/* global defineProps */

export default /*#__PURE__*/_defineComponent({
  __name: 'CategoriesSection',
  props: {
    section: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "99cbf33e": (menuTextColor.value),
  "523e996e": (menuTextHoverColor.value)
}))

const props = __props

const modules = [Pagination, FreeMode]
const style = computed(() => props.section.settings?.style ?? 'carousel')
const carouselBreakpoints = { 0: { slidesPerView: 4, spaceBetween: 20 }, 450: { slidesPerView: 5, spaceBetween: 20 }, 900: { slidesPerView: 6, spaceBetween: 40 }, 1200: { slidesPerView: 9, spaceBetween: 40 } }

const menuTextColor = computed(() => restaurant.value.restaurantDesignCustom?.menuTextColor || 'var(--sf-text)')
const menuTextHoverColor = computed(() => restaurant.value.restaurantDesignCustom?.menuTextHoverColor || 'var(--sf-primary)')

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sf-categories", `sf-categories--${style.value}`])
  }, [
    (_ctx.section.settings.title)
      ? (_openBlock(), _createElementBlock("h5", _hoisted_1, _toDisplayString(_ctx.section.settings.title), 1))
      : _createCommentVNode("", true),
    (style.value === 'carousel')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_unref(categories)?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_unref(Swiper), {
                  "slides-per-view": 9,
                  "space-between": 50,
                  pagination: true,
                  modules: modules,
                  breakpoints: carouselBreakpoints,
                  "free-mode": true,
                  class: "pb-10"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categories), (category) => {
                      return (_openBlock(), _createBlock(_unref(SwiperSlide), {
                        key: category.id
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_RouterLink, {
                            to: { name: 'categories.show', params: { id: category.id } }
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("img", {
                                  class: "sf-category-img",
                                  src: _unref(getProductImage)(category),
                                  alt: "",
                                  onError: _cache[0] || (_cache[0] = ($event: any) => (($event.target as HTMLImageElement).src = '/assets/no-image.png'))
                                }, null, 40, _hoisted_4),
                                _createElementVNode("p", _hoisted_5, _toDisplayString(category.name), 1)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (!_unref(categories)?.length && !_unref(restaurant)?.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_unref(Swiper), {
                  "slides-per-view": 9,
                  "space-between": 50,
                  pagination: true,
                  modules: modules,
                  breakpoints: carouselBreakpoints,
                  "free-mode": true,
                  class: "pb-10"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1,2,3,4,5,6,7,8,9], (i) => {
                      return _createVNode(_unref(SwiperSlide), { key: i }, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 2
                      }, 1024)
                    }), 64))
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : (style.value === 'grid')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            (_unref(categories)?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categories), (category) => {
                    return (_openBlock(), _createBlock(_component_RouterLink, {
                      key: category.id,
                      to: { name: 'categories.show', params: { id: category.id } },
                      class: "sf-categories__tile group"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("img", {
                            src: _unref(getProductImage)(category),
                            alt: "",
                            class: "transition-transform duration-300 group-hover:scale-105",
                            onError: _cache[1] || (_cache[1] = ($event: any) => (($event.target as HTMLImageElement).src = '/assets/no-image.png'))
                          }, null, 40, _hoisted_10)
                        ]),
                        _createElementVNode("p", _hoisted_11, _toDisplayString(category.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  }), 128))
                ]))
              : (!_unref(restaurant)?.id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1,2,3,4,5,6,7,8], (i) => {
                      return _createElementVNode("div", {
                        key: i,
                        class: "sf-categories__tile"
                      }, _hoisted_15)
                    }), 64))
                  ]))
                : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            (_unref(categories)?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categories), (category) => {
                    return (_openBlock(), _createBlock(_component_RouterLink, {
                      key: category.id,
                      to: { name: 'categories.show', params: { id: category.id } },
                      class: "sf-categories__chip"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(category.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  }), 128))
                ]))
              : (!_unref(restaurant)?.id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1,2,3,4,5,6], (i) => {
                      return _createElementVNode("span", {
                        key: i,
                        class: "sf-categories__chip sf-skeleton",
                        style: {"width":"6rem"}
                      }, " ")
                    }), 64))
                  ]))
                : _createCommentVNode("", true)
          ], 64))
  ], 2))
}
}

})